import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import TransportState from '../types/TransportState'

const getters: GetterTree<TransportState, RootState> = {
  getTransport: state => state.transport
}

export default getters
